import { BadgeCheck, Compass, Sprout } from "lucide-react";

/**
 * What sets the service apart, in three promises. Others write fast and in
 * volume; this one writes correctly, aims before it writes, and keeps
 * improving what it published. Shown on the sign-in screens and the landing page.
 */
export const PROMISES = [
  { icon: BadgeCheck, title: "正しく書く", text: "国税庁・e-Gov 法令検索・裁判所などの一次資料で AI が確かめ、最後は先生が監修して世に出します。" },
  { icon: Compass, title: "狙って書く", text: "検索上位を読み、上位表示の難しさを5段階で判定。勝てる言葉から書きます。" },
  { icon: Sprout, title: "育てて届ける", text: "公開後も順位を毎週確かめ、上がらない記事には改善案を出します。" },
] as const;
